import moment from "moment";

export const actionButton = (params) => {};

// const categoryMapping = categoryIdToNameMapRedux

// const categoryMapping = {
//   1: "Raw Material",
//   2: "Premix",//
//   3: "Broken Rice",
//   4: "FRK",
//   5: "Miller(FR)",
//   6: "Rice",
// };

export const LISTING_GENERIC_HEADER = (categoryMapping, translate) =>[
  {
    field: "batchNo",
    headerName: translate('shipmentNo'),
    minWidth: 170,
    hide: false,
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    filterParams: {
      buttons: ["apply", "clear"],
    },
    valueFormatter: (params) => {
      return params?.data?.lotNo || params?.data?.batchNo
    },
  },
  {
    field: "categoryId",
    headerName: translate('type'),
    minWidth: 150,
    hide: false,
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    filterParams: {
      buttons: ["apply", "clear"],
    },
    valueFormatter: (params) => {
      return translate(categoryMapping[params?.data?.categoryId]).replace("MILLER", 'MILLER(FR)');
    },
  },
  {
    field: "state.displayName",
    headerName: translate('stage'),
    minWidth: 150,
    hide: false,
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    filterParams: {
      buttons: ["apply", "clear"],
    },
    valueFormatter: (params) => {
      return translate(params?.data?.state?.displayName.toLowerCase());
    }
  },
  {
    field: "sampleSentDate",
    headerName: translate('sampleSentDate'),
    minWidth: 150,
    hide: false,
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    filterParams: {
      buttons: ["apply", "clear"],
    },
    valueFormatter: (params) => {
      return params?.data?.sampleSentDate
        ? moment.utc(params.data.sampleSentDate).format("DD-MM-YYYY")
        : "";
    },
  },
  {
    field: "testDate",
    headerName: translate('testDate'),
    minWidth: 150,
    hide: false,
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    filterParams: {
      buttons: ["apply", "clear"],
    },

    valueFormatter: (params) => {
      return params?.data?.testDate
        ? moment.utc(params.data.testDate).format("DD-MM-YYYY")
        : "";
    },
  },
];
